/**
 * Trusted Financial News Sources
 * Curated list of reputable financial news websites for domain filtering
 */

/**
 * Free/Accessible financial news sources
 */
export const FREE_FINANCIAL_SOURCES = [
  'reuters.com',
  'cnbc.com',
  'finance.yahoo.com',
  'marketwatch.com',
  'investopedia.com',
  'seekingalpha.com',
  'fool.com', // Motley Fool
  'benzinga.com',
];

/**
 * Premium financial news sources (may have paywalls)
 */
export const PREMIUM_FINANCIAL_SOURCES = [
  'bloomberg.com',
  'wsj.com', // Wall Street Journal
  'ft.com', // Financial Times
  'barrons.com',
  'forbes.com',
];

/**
 * General news with strong financial coverage
 */
export const GENERAL_NEWS_SOURCES = [
  'nytimes.com',
  'washingtonpost.com',
  'theguardian.com',
  'bbc.com',
];

/**
 * All trusted financial sources combined
 */
export const ALL_FINANCIAL_SOURCES = [...FREE_FINANCIAL_SOURCES, ...PREMIUM_FINANCIAL_SOURCES];

/**
 * Comprehensive list including general news
 */
export const ALL_NEWS_SOURCES = [...ALL_FINANCIAL_SOURCES, ...GENERAL_NEWS_SOURCES];

/**
 * Default sources for market news (most accessible)
 */
export const DEFAULT_MARKET_NEWS_SOURCES = [
  'reuters.com',
  'cnbc.com',
  'finance.yahoo.com',
  'marketwatch.com',
  'bloomberg.com',
];

/**
 * Sources focused on stock-specific news
 */
export const STOCK_NEWS_SOURCES = [
  'reuters.com',
  'cnbc.com',
  'finance.yahoo.com',
  'marketwatch.com',
  'seekingalpha.com',
  'benzinga.com',
  'bloomberg.com',
];
